export interface IRGBA {
  red: number;
  green: number;
  blue: number;
  alpha: number;
}

export const hexToRgb = (hex: string): number[] => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? [parseInt(result[1], 16) / 255.0, parseInt(result[2], 16) / 255.0, parseInt(result[3], 16) / 255.0]
    : [1.0, 1.0, 1.0];
};

export const hexToIRGBA = (hex: string, alpha?: number): IRGBA => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        red: parseInt(result[1], 16) / 255.0,
        green: parseInt(result[2], 16) / 255.0,
        blue: parseInt(result[3], 16) / 255.0,
        alpha: alpha ?? 1.0,
      }
    : {
        red: 1.0,
        green: 1.0,
        blue: 1.0,
        alpha: 1.0,
      };
};

/*
background: '#212F41',
        clock: '#FF9800',
        groupLabel1: '#ffffff',
        groupLabel2: '#2d3e51',
        evenRow: '#212F41',
        oddRow: '#1F2C3D',
        intervalBar: '#FF9800',
        timeScale1: '#ffffff',
        timeScale2: '#2d3e51'*/
export class TimelineThemeGL {
  public clearColor: IRGBA = {
    red: 0.129,
    green: 0.184,
    blue: 0.255,
    alpha: 1.0,
  };
  public hoverFlightColor: IRGBA = { red: 1, green: 1, blue: 1, alpha: 1.0 };
  public selectedFlightColor: IRGBA = {
    red: 1.0,
    green: 0.596,
    blue: 0.0,
    alpha: 1.0,
  };
  public clockColor!: string;
  public intervalBar!: string;
  public selectedRow!: IRGBA;
  public evenRow!: IRGBA;
  public oddRow!: IRGBA;
  public minorTimeColor!: string;
  public majorTimeColor!: string;
  public timeHighlightBar!: string;
  public timeAxisLineColor!: IRGBA;
  public blurEffect!: IRGBA;
  public scrollBarBackGround!: IRGBA;
  public scrollBarThumb!: IRGBA;
  public scrollBarThumbHover!: IRGBA;
  public scrollBarThumbClickedOn!: IRGBA;
  public biddingActiveButtonColor!: string;
  public updateTheme = (theme: any): void => {
    this.clearColor = hexToIRGBA(theme.background);
    this.selectedRow = hexToIRGBA(theme.selectedRow);
    this.evenRow = hexToIRGBA(theme.evenRow);
    this.oddRow = hexToIRGBA(theme.oddRow);
    this.clockColor = theme.clock;
    this.intervalBar = theme.intervalBar;
    this.minorTimeColor = theme.timeScale2;
    this.majorTimeColor = theme.timeScale1;
    this.timeHighlightBar = "rgba(255, 255, 255, 0.05)"; // theme.timeHighlightBar
    this.timeAxisLineColor = {
      red: 0.255,
      green: 0.255,
      blue: 0.255,
      alpha: 1.0,
    };
    this.blurEffect = { red: 0.063, green: 0.09, blue: 0.125, alpha: 0.8 };
    this.scrollBarBackGround = hexToIRGBA(theme.scrollBarBackground);
    this.scrollBarThumb = hexToIRGBA(theme.scrollBarThumb.base);
    this.scrollBarThumbHover = hexToIRGBA(theme.scrollBarThumb.hover);
    this.scrollBarThumbClickedOn = hexToIRGBA(theme.scrollBarThumb.active);
    this.biddingActiveButtonColor = theme.biddingActiveButtonColor;
  };
}
